import { errorHandle } from 'redux/actions/error';
import message from 'antd/lib/message';
import moment from 'moment';
import apiService from 'shared/services/ApiService';
import {
  SET_LIST_ORDER,
  PROCESSING,
  SET_ALL_LIST_ORDER,
  PROCESSING_CSV,
  GET_SINGLE_ORDER,
  GET_SINGLE_ORDER_SUCCESS,
  GET_SINGLE_ORDER_FAILED,
  GET_SINGLE_ORDER_STATUS,
  GET_SINGLE_ORDER_STATUS_SUCCESS,
  GET_SINGLE_ORDER_STATUS_FAILED,
  SET_LIST_PARTNER,
  SET_PARTNER_DETAIL,
  UPDATE_PARTNER,
  SET_LIST_CLIENT,
  SET_CLIENT_DETAILS,
  SET_GET_CLIENT_DETAILS_LOADING,
  SET_CREATE_NEW_CLIENT_LOADING,
  SET_REVOKE_CLIENT_LOADING,
  SET_REFRESH_CLIENT_LOADING,
  UPDATE_PARTNER_EDIT_STEP,
  INIT_PARTNER_EDIT,
} from './types';
const { deliveryApiService } = apiService.getInstance();

export const setListOrder = (data, filter) => ({
  type: SET_LIST_ORDER,
  payload: data,
  filter,
});

export const setProcessing = () => ({
  type: PROCESSING,
});

export const getListOrder = (paginationUrl, paramUrl) => dispatch => {
  dispatch(setProcessing());
  const url = `/deliveries?${paginationUrl}${paramUrl}`;

  deliveryApiService
    .get(url)
    .then(response => {
      const { payload, pagination } = response.data;
      dispatch(setListOrder(payload, pagination));
    })
    .catch(error => {
      errorHandle(error);
      dispatch(setListOrder([]));
    });
};

export const setSingleOrderSuccess = data => ({
  type: GET_SINGLE_ORDER_SUCCESS,
  payload: { orderDetail: data },
});
export const setSingleOrderFailed = () => ({
  type: GET_SINGLE_ORDER_FAILED,
  payload: { orderDetail: {} },
});
export const getSingleOrder = orderId => dispatch => {
  dispatch({ type: GET_SINGLE_ORDER });

  deliveryApiService
    .get(`deliveries/${orderId}`)
    .then(response => {
      dispatch(setSingleOrderSuccess(response.data));
    })
    .catch(dispatch(setSingleOrderFailed()));
};

export const setSingleOrderStatusSuccess = data => ({
  type: GET_SINGLE_ORDER_STATUS_SUCCESS,
  payload: { orderTrackStatus: data },
});
export const setSingleOrderStatusFailed = () => ({
  type: GET_SINGLE_ORDER_STATUS_FAILED,
  payload: { orderTrackStatus: {} },
});

export const getSingleOrderStatus = orderId => dispatch => {
  dispatch({ type: GET_SINGLE_ORDER_STATUS });

  deliveryApiService
    .get(`deliveries/${orderId}/status`)
    .then(response => {
      dispatch(setSingleOrderStatusSuccess(response.data));
    })
    .catch(dispatch(setSingleOrderStatusFailed()));
};

export const setAllListOrder = data => ({
  type: SET_ALL_LIST_ORDER,
  payload: data,
});
export const setProcessingCSV = () => ({
  type: PROCESSING_CSV,
});
export const getAllListOrder = (
  paginationUrl,
  paramUrl,
  successCallback,
  errorCallback,
) => dispatch => {
  dispatch(setProcessingCSV());
  const url = `/deliveries?${paginationUrl}${paramUrl}`;

  deliveryApiService
    .get(url)
    .then(response => {
      dispatch(setAllListOrder(response.data));
      successCallback();
    })
    .catch(onErrorAllListOrder(errorCallback, dispatch));
};

export const onErrorAllListOrder = (errorCallback, dispatch) => error => {
  dispatch(setAllListOrder([]));
  errorHandle(error);
  throw error;
};

export const formatCSV = (data, convertStatusFunc) => {
  const result = data.map((item, index) => ({
    no: index + 1,
    order_id: item.delivery_id,
    public_id: item.public_id,
    acquirement_id: item.dana_acquirement_id,
    sender_name: item.sender_name,
    phone_number: item.sender_phone,
    carrier_name: item.carrier_name,
    partner_delivery_id: item.partner_delivery_id,
    order_timestamp: moment(item.order_placed_timestamp).format(
      'YYYY-MM-DD HH:mm:ss',
    ),
    status: convertStatusFunc(true)(item),
  }));
  return result;
};

// PARTNER

export const setListPartner = (data, filter) => ({
  type: SET_LIST_PARTNER,
  payload: data,
  filter,
});

export const getListPartner = (paginationUrl, paramUrl) => dispatch => {
  dispatch(setProcessing());
  const url = `/partners?${paginationUrl}${paramUrl}`;

  deliveryApiService
    .get(url)
    .then(response => {
      const { payload, pagination } = response.data;
      dispatch(setListPartner(payload, pagination));
    })
    .catch(error => {
      errorHandle(error);
      dispatch(setListPartner([]));
    });
};

export const getPartnerDetail = (partnerId, isEditForm) => dispatch => {
  if (isEditForm) {
    dispatch(deliveries.initPartnerEdit());
  } else {
    dispatch(setProcessing());
  }

  deliveryApiService
    .get(`partners/${partnerId}`)
    .then(response => {
      dispatch({ type: SET_PARTNER_DETAIL, payload: response.data.payload });
    })
    .catch(() => {
      dispatch({ type: SET_PARTNER_DETAIL, payload: {} });
    });
};

export const updatePartner = (
  partnerId,
  values,
  callbackSuccess,
  isTnc,
) => dispatch => {
  dispatch(setProcessing());

  deliveryApiService
    .put(`partners/${partnerId}`, values)
    .then(() => {
      dispatch({ type: UPDATE_PARTNER });

      if (isTnc) {
        message.success({
          content: 'Update Partner TnC Success',
          key: 'updatePartner',
        });
      }

      if (callbackSuccess) {
        callbackSuccess();
      }
    })
    .catch(() => {
      message.error({
        content: isTnc ? 'Update Partner TnC Failed' : 'Update Partner Failed',
        key: 'updatePartner',
      });
      dispatch({ type: UPDATE_PARTNER });
    });
};

export const setListClient = (data, filter) => ({
  type: SET_LIST_CLIENT,
  payload: data,
  filter,
});

export const getListClient = (
  paginationUrl,
  paramUrl = '',
  successCallback = null,
  errorCallback = null,
) => dispatch => {
  dispatch(deliveries.setProcessing());

  const url = `client?${paginationUrl}${paramUrl}`;

  deliveryApiService
    .get(url)
    .then(
      deliveries.onGetListClientSuccess(
        dispatch,
        successCallback,
        errorCallback,
      ),
    )
    .catch(deliveries.onGetListClientError(dispatch, errorCallback));
};

export const onGetListClientSuccess = (
  dispatch,
  successCallback,
  errorCallback,
) => response => {
  if (response.status === 200) {
    const { payload, pagination } = response.data;
    dispatch(deliveries.setListClient(payload, pagination));

    if (successCallback) {
      successCallback();
    }
  } else {
    deliveries.onGetListClientError(dispatch, errorCallback)('');
  }
};

export const onGetListClientError = (dispatch, errorCallback) => error => {
  try {
    errorHandle(error);
  } catch (err) {
    dispatch(deliveries.setListClient([]));
    if (errorCallback) {
      errorCallback(err);
    }
  }
};

export const setClientDetails = clientData => ({
  type: SET_CLIENT_DETAILS,
  client: clientData,
});
export const setGetClientDetailsLoading = isloading => ({
  type: SET_GET_CLIENT_DETAILS_LOADING,
  loading: isloading,
});

export const getClientDetails = (
  clientId,
  successCallback,
  errorCallback,
) => dispatch => {
  dispatch(deliveries.setGetClientDetailsLoading(true));

  const url = `client/${clientId}/reveal`;

  deliveryApiService
    .get(url)
    .then(
      deliveries.onGetClientDetailsSuccess(
        dispatch,
        successCallback,
        errorCallback,
      ),
    )
    .catch(deliveries.onGetClientDetailsError(dispatch, errorCallback));
};

export const onGetClientDetailsSuccess = (
  dispatch,
  successCallback,
  errorCallback,
) => response => {
  if (response.status === 200) {
    const { payload } = response.data;
    dispatch(deliveries.setClientDetails(payload));

    if (successCallback) {
      successCallback();
    }
  } else {
    deliveries.onGetClientDetailsError(dispatch, errorCallback)('');
  }
};

export const onGetClientDetailsError = (dispatch, errorCallback) => error => {
  try {
    errorHandle(error);
  } catch (err) {
    dispatch(deliveries.setClientDetails({}));
    if (errorCallback) {
      errorCallback(err);
    }
  }
};

export const setCreateNewClientLoading = isloading => ({
  type: SET_CREATE_NEW_CLIENT_LOADING,
  loading: isloading,
});

export const createNewClient = (
  params,
  successCallback,
  errorCallback,
) => dispatch => {
  dispatch(deliveries.setCreateNewClientLoading(true));

  deliveryApiService
    .post(`client`, params)
    .then(
      deliveries.onCreateNewClientSuccess(
        dispatch,
        successCallback,
        errorCallback,
      ),
    )
    .catch(deliveries.onCreateNewClientError(dispatch, errorCallback));
};

export const onCreateNewClientSuccess = (
  dispatch,
  successCallback,
  errorCallback,
) => response => {
  if (response.status === 200) {
    dispatch(deliveries.setCreateNewClientLoading(false));

    if (successCallback) {
      successCallback();
    }
  } else {
    deliveries.onCreateNewClientError(dispatch, errorCallback)('');
  }
};

export const onCreateNewClientError = (dispatch, errorCallback) => error => {
  try {
    errorHandle(error);
  } catch (err) {
    dispatch(deliveries.setCreateNewClientLoading(false));
    if (errorCallback) {
      errorCallback(err);
    }
  }
};

export const setRevokeClientLoading = isloading => ({
  type: SET_REVOKE_CLIENT_LOADING,
  loading: isloading,
});

export const revokeClient = (
  clientId,
  successCallback,
  errorCallback,
) => dispatch => {
  dispatch(deliveries.setRevokeClientLoading(true));

  const url = `client/${clientId}`;

  deliveryApiService
    .delete(url)
    .then(
      deliveries.onRevokeClientSuccess(
        dispatch,
        successCallback,
        errorCallback,
      ),
    )
    .catch(deliveries.onRevokeClientError(dispatch, errorCallback));
};

export const onRevokeClientSuccess = (
  dispatch,
  successCallback,
  errorCallback,
) => response => {
  if (response.status === 204) {
    dispatch(deliveries.setRevokeClientLoading(false));

    if (successCallback) {
      successCallback();
    }
  } else {
    deliveries.onRevokeClientError(dispatch, errorCallback)('');
  }
};

export const onRevokeClientError = (dispatch, errorCallback) => error => {
  try {
    errorHandle(error);
  } catch (err) {
    dispatch(deliveries.setRevokeClientLoading(false));
    if (errorCallback) {
      errorCallback(err);
    }
  }
};

//-----
export const setRefreshClientLoading = isloading => ({
  type: SET_REFRESH_CLIENT_LOADING,
  loading: isloading,
});

export const refreshClient = (
  clientId,
  successCallback,
  errorCallback,
) => dispatch => {
  dispatch(deliveries.setRefreshClientLoading(true));

  const url = `client/${clientId}`;
  const param = {
    refresh_key: true,
  };

  deliveryApiService
    .put(url, param)
    .then(
      deliveries.onRefreshClientSuccess(
        dispatch,
        successCallback,
        errorCallback,
      ),
    )
    .catch(deliveries.onRefreshClientError(dispatch, errorCallback));
};

export const onRefreshClientSuccess = (
  dispatch,
  successCallback,
  errorCallback,
) => response => {
  if (response.status === 200) {
    const { payload } = response.data;
    dispatch(deliveries.setClientDetails(payload));
    dispatch(deliveries.setRefreshClientLoading(false));

    if (successCallback) {
      successCallback();
    }
  } else {
    deliveries.onRefreshClientError(dispatch, errorCallback)('');
  }
};

export const onRefreshClientError = (dispatch, errorCallback) => error => {
  try {
    errorHandle(error);
  } catch (err) {
    dispatch(deliveries.setRefreshClientLoading(false));
    if (errorCallback) {
      errorCallback(err);
    }
  }
};

export const updatePartnerEditStep = step => ({
  type: UPDATE_PARTNER_EDIT_STEP,
  step,
});

export const initPartnerEdit = () => ({
  type: INIT_PARTNER_EDIT,
});

const deliveries = {
  setListOrder,
  setProcessing,
  getListOrder,
  setSingleOrderSuccess,
  setSingleOrderFailed,
  getSingleOrder,
  setSingleOrderStatusSuccess,
  setSingleOrderStatusFailed,
  getSingleOrderStatus,
  setAllListOrder,
  setProcessingCSV,
  getAllListOrder,
  onErrorAllListOrder,
  formatCSV,
  setListPartner,
  getListPartner,
  getPartnerDetail,
  updatePartner,
  setListClient,
  getListClient,
  onGetListClientSuccess,
  onGetListClientError,
  setClientDetails,
  setGetClientDetailsLoading,
  getClientDetails,
  onGetClientDetailsSuccess,
  onGetClientDetailsError,
  setCreateNewClientLoading,
  createNewClient,
  onCreateNewClientSuccess,
  onCreateNewClientError,
  setRevokeClientLoading,
  revokeClient,
  onRevokeClientSuccess,
  onRevokeClientError,
  setRefreshClientLoading,
  refreshClient,
  onRefreshClientSuccess,
  onRefreshClientError,
  updatePartnerEditStep,
  initPartnerEdit,
};

export default deliveries;
